import React from "react";
import { View } from '../../../components/templates/View';
import { CDGestionVulnerabilidades, CMGestionVulnerabilidades } from '../organisms';
import { useViewport } from "../../../hooks";

const GestionVulnerabilidades = () => {

    const { width } = useViewport();

    return(
        width > 850 ?
            <>
                <View children={ <CDGestionVulnerabilidades /> }/>
            </>
        :
            <>
                <View children={ <CMGestionVulnerabilidades/> }/>
            </>
    );
}

export default GestionVulnerabilidades;

